import {Injectable} from "@angular/core";
import {ApiService} from "@core/api/api.service";
import {ReplicationTable} from "@data/interefaces/itf_system.interfaces";

@Injectable({
  providedIn: 'root'
})
export class ReplicationTableService {
  constructor(private _apiService: ApiService) {
  }

  public getReplicationTables(): Promise<ReplicationTable[]> {
    return this._apiService.makeGetServiceCall<ReplicationTable[]>(`/v2/api/itf-system/replication-table`);
  }
}
